import { SUPABASE_URL, SUPABASE_ANON_KEY } from '../config/env';

const supabaseRequest = async (endpoint, options = {}) => {
  const response = await fetch(`${SUPABASE_URL}${endpoint}`, {
    ...options,
    headers: {
      'apikey': SUPABASE_ANON_KEY,
      'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Request failed' }));
    throw new Error(error.message || 'Request failed');
  }
  return response.json();
};

export class TLManagerService {
  static async getPerformanceData() {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/tl_manager_get_performance_data`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      return { success: true, data: (Array.isArray(data) ? data[0] : data) || {}, error: null };
    } catch (error) {
      console.error('Error fetching performance data:', error);
      return { success: false, data: {}, error: error.message };
    }
  }

  static async getPaymentVerifications() {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/tl_manager_get_payment_verifications`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching payment verifications:', error);
      return { success: false, data: [], error: error.message };
    }
  }

  static async verifyPayment(paymentId, verified) {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/tl_manager_verify_payment`, {
        method: 'POST',
        body: JSON.stringify({ p_payment_id: paymentId, p_verified: verified }),
      });
      return { success: true, data, error: null };
    } catch (error) {
      console.error('Error verifying payment:', error);
      return { success: false, error: error.message };
    }
  }

  static async getBookedOrders() {
    try {
      const data = await supabaseRequest(`/rest/v1/rpc/tl_manager_get_booked_orders`, {
        method: 'POST',
        body: JSON.stringify({}),
      });
      return { success: true, data: data || [], error: null };
    } catch (error) {
      console.error('Error fetching booked orders:', error);
      return { success: false, data: [], error: error.message };
    }
  }
}

